import * as React from "react";
import {useEffect, useState} from "react";
import {Redirect, RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {handleNavigation, indexPath, routePaths} from "egold/routes";
import {TextField} from "components/common/inputFunctions";
import {BankDetailFields, initialValidationStatus, insideHeader, renderProceed, ToastBgColor, validateBankDetails} from "egold/utils";
import {IEgoldUserDetails, IValidation, IVerifySellPrice} from "StateInterface";
import {sellGold, showToast, updateVerifiedBankDetails} from "egold/actions";
import {vendor} from "egold/egold-config";
import {getRequestExternal} from "utils/externalApiCalls";
import Modal from "components/Modal";
import {imageBaseUrl} from "config";
import {verifyBankAccountAndPan} from "egold/api";
import Loading from "components/loading";
import {CC_EMAIL_ID} from "utils/variables";
import {EVENT_NAMES} from "Dashboard/utils";

export interface IBankInput {
    ACCOUNT_NO: string;
    RE_ACCOUNT_NO: string;
    IFSC: string;
    NAME: string;
    AC_HOLDER_NAME: string;
}
const initialBankDetails = {
    ACCOUNT_NO: "",
    RE_ACCOUNT_NO: "",
    IFSC: "",
    NAME: "",
    AC_HOLDER_NAME: "",
};
interface IVerificationResponse {
    isVerified: boolean;
    blacklistedForPennydrop?: boolean;
    error: string;
}
export interface IVerifiedBankDetails {
    accountNumber: string;
    bankName: string;
    bankRRN: string;
    beneficiaryName: string;
    ifsc: string;
    verifiedAt: number;
}

export interface IBankVerificationDetails {
    blacklistedForPennydrop?: boolean;
    error?: string;
    isVerified?: boolean;
    panNameMatch?: boolean;
    bankAccount?: IVerifiedBankDetails;
}
const initialBankVerificationDetails = {
    isVerified: null,
    panNameMatch: null,
    bankAccount: null,
}
interface IConnectProps {
    dispatch?: (action: any) => void;
    eGoldUserDetails: IEgoldUserDetails;
    verifySellPrice: IVerifySellPrice;
    bankDetailsValidStatus: string;
}
const  minAmountForBankVerification = 100 ;

enum ERROR_MSGS {
    panNameNotMatch = "Your Pan card name and Bank Account name do not Match, you can only receive sell procceds into your account.",
    wrongBankDetails =  "We couldn't verify your bank account details please enter correct details.",
    errorMsg = "Something Went Wrong. Please Try Again!"
}

function BankDetails(props: IConnectProps & RouteComponentProps) {
    const [bankDetails, updateBankDetails] = useState<IBankInput>(initialBankDetails);
    const [isModalActive, updateModalActiveStatus] = useState<boolean>(false);
    const [ifscResponse, setIfscResponse] = useState("");
    const [validationStatus, updateValidationStatus] = useState<IValidation>(initialValidationStatus);
    const [isChecked, updateIsChecked] = useState<boolean>(false);
    const [redirectRequired , updateRedirectRequired] = useState<boolean>(false);
    const [verifyBank, setVerifyBank] = useState<IBankVerificationDetails>(initialBankVerificationDetails);
    const [loading, setLoading] = useState<boolean>();
    const [bankVerificationErrorMsg, setBankVerificationErrorMsg] = useState<string>(null);

    useEffect(() => {
        if (!props.verifySellPrice) {
            updateRedirectRequired(true);
        }
    }, []);
    function handleChange(fieldName: BankDetailFields, value: number | string) {
        let ifscDetails = null;
        if (fieldName === BankDetailFields.IFSC && String(value).length === 11) {
            ifscDetails  = getRequestExternal(`https://ifsc.razorpay.com/${value}`, null);
            ifscDetails.then((response: any) => {
                const resp = JSON.parse(response);
                setIfscResponse("");
                updateBankDetails((prevState) => {
                    return {
                        ...prevState,
                        [BankDetailFields.NAME]: resp.BANK,
                    };
                });
            });
            ifscDetails.catch((err) => {
                setIfscResponse(err.status === 404 ? "Incorrect IFSC code!" : "Something went wrong!");
            });
        }
        updateBankDetails((prevState) => {
            return {
                ...prevState,
                [fieldName]: value,
            };
        });
    }
    const saveVerifiedBankDetails = (bankDetails) => {
        props.dispatch(updateVerifiedBankDetails(bankDetails));
        handleNavigation(routePaths.VERIFIED_BANK_ACCOUNT);
    }
    const setErrorMsg = (res) => {
        res.isVerified ? res.panNameMatch ? saveVerifiedBankDetails(res)  
                :  setBankVerificationErrorMsg(ERROR_MSGS.panNameNotMatch) 
                :  setBankVerificationErrorMsg(ERROR_MSGS.errorMsg);
    }
    const handelingBankVerificationResponse = (verificationRes: IVerificationResponse, msg: string) => {
        setVerifyBank(verificationRes);
        setBankVerificationErrorMsg(msg);
        setLoading(false);
    }
    const handleSubmitPopUp = async () => {
        const bankInfo = {
            account_number: bankDetails.ACCOUNT_NO,
            ifsc: bankDetails.IFSC,
            txn_id: props.verifySellPrice.txn_id,
            customer_name: bankDetails.AC_HOLDER_NAME,
            vendor_id: props.eGoldUserDetails.vendor_id,
            bank_name: bankDetails.NAME,
        };
        if (props.location.state.amountEnteredInRupees < minAmountForBankVerification){
            props.dispatch(sellGold(vendor.SAFEGOLD, bankInfo));
        }
        else {
            try {
                setLoading(true);
                const res = await verifyBankAccountAndPan(bankDetails.ACCOUNT_NO, bankDetails.IFSC);
                if (res.status === 200) {
                    setErrorMsg(res.data);
                    setVerifyBank(res.data);
                    setLoading(false);
                }
            } catch (error) {
                if (error.response.status === 400){
                    error.response.data && error.response.data.blacklistedForPennydrop ? 
                        handelingBankVerificationResponse(error.response.data, ERROR_MSGS.errorMsg) :
                        handelingBankVerificationResponse(error.response.data, ERROR_MSGS.wrongBankDetails);
                } else {
                    props.dispatch(showToast(ToastBgColor.WARNING, ERROR_MSGS.errorMsg));
                    updateModalActiveStatus(false);
                }
            }
        }
    };
    const renderModalChild = () => {
        return ((!verifyBank.isVerified || !verifyBank.panNameMatch) && bankVerificationErrorMsg ?
            <div className="error-container text-dark pl-4 pt-4">
                <p>{bankVerificationErrorMsg}</p>
                <div className='change_bank_button'onClick={onChangeBankClickHandle}>
                    Change Bank Account
                </div>
                <div className='contact-us-text'>
                    Please mail us at:
                    <h6 className="contact-us-link">
                        <a className="contact-us-link" href="mailto:support@myshubhlife.com">{CC_EMAIL_ID}</a>
                    </h6>   
                    For further Support.
                </div>
            </div> : 
            <div className="text-dark pl-4 pt-4">
                <h5 className="please-confirm">Please Confirm! </h5>
                <div>
                    <p className="account-detial">Your sell amount will be credited to the following account.</p>                  
                    <h6>Name: {bankDetails.AC_HOLDER_NAME}</h6>
                    <h6>IFSC: {bankDetails.IFSC}</h6>
                    <h6>Ac No: {bankDetails.ACCOUNT_NO}</h6>
                    <h6>Bank: {bankDetails.NAME}</h6>
                </div>
            </div>
        )
    }
    const handleProceed = () => {
        const validation = validateBankDetails(bankDetails);
        if (validation.status) {
            updateModalActiveStatus(true);
        }
        updateValidationStatus(validation);
    };
    const handleChecked = () => {
        updateIsChecked(!isChecked);
    };
    const onChangeBankClickHandle = () => {
        setVerifyBank(initialBankVerificationDetails);
        updateBankDetails(initialBankDetails);
        setBankVerificationErrorMsg(null);
        updateModalActiveStatus(false);
    }
    if (redirectRequired) {
        return <Redirect to={`${indexPath}${routePaths.SELL_GOLD}`}/>;
    }
    if (props.bankDetailsValidStatus === "SUCCESS") {
        return <Redirect to={{pathname: `${indexPath}${routePaths.ORDER_SUCCESS}`}}/>;
    }
    if (props.bankDetailsValidStatus === "FAILED") {
        return <Redirect to={{pathname: `${indexPath}${routePaths.ORDER_FAIL}`}}/>;
    }
    return (
        <div>
            {insideHeader("Confirm Details", props.history.goBack)}
            <div className="bank-container mx-2">
                {renderBankDetailFields(bankDetails, validationStatus, handleChange, ifscResponse)}
                {renderCheckField(handleChecked, bankDetails.AC_HOLDER_NAME)}
                {renderProceed("Confirm", handleProceed, !isChecked)}
            </div>
            <Modal
                active = {isModalActive}
                cancellable = {true}
                cancelTitle = "Cancel"
                onSubmit={!bankVerificationErrorMsg && handleSubmitPopUp}
                submitTitle={!bankVerificationErrorMsg && "Confirm"}
                onClose = {onChangeBankClickHandle}
            >
                <div className="modal-child-container">
                    <Loading active={loading} msg={"Verifying your Bank details"} />
                    {renderModalChild()}
                </div>
            </Modal>
        </div>
    );
}

function renderBankDetailFields(
    bankDetails: IBankInput,
    validationStatus: IValidation,
    handleChange: any,
    ifscResponse: string,
) {
    return(
        <div>
            <div className="top-text mb-4">
                <h4 className="egold-sub-text mt-3">Bank Details</h4>
                <small>
                    Please share the details of the bank account to which you would like the amount to be deposited
                </small>
            </div>
            <div className="d-flex">
                <div>
                    <img className="bank-icons" src={`${imageBaseUrl}/img/icons/eGold/bank-icon.png`}/>
                </div>
                <TextField label="Beneficiary Name"
                           value={bankDetails.AC_HOLDER_NAME}
                           fieldName={BankDetailFields.AC_HOLDER_NAME}
                           onChange={handleChange}
                           type="text"
                           error={validationStatus.type === BankDetailFields.AC_HOLDER_NAME ? validationStatus.msg : ""}
                           inputTextClass="line-input-box"
                           containerClass="input-container flex-fill"
                />
            </div>
            <div className="d-flex">
                <div>
                    <img className="bank-icons" src={`${imageBaseUrl}/img/icons/eGold/bank-icon.png`}/>
                </div>
                <TextField label="Account Number"
                           value={bankDetails.ACCOUNT_NO}
                           fieldName={BankDetailFields.ACCOUNT_NO}
                           onChange={handleChange}
                           type="text"
                           error={validationStatus.type === BankDetailFields.ACCOUNT_NO ? validationStatus.msg : ""}
                           inputTextClass="line-input-box"
                           containerClass="input-container flex-fill"
                />
            </div>
           <div className="d-flex">
               <div>
                   <img className="bank-icons" src={`${imageBaseUrl}/img/icons/eGold/bank-icon.png`}/>
               </div>
               <TextField label="Re-enter Account Number"
                          value={bankDetails.RE_ACCOUNT_NO}
                          fieldName={BankDetailFields.RE_ACCOUNT_NO}
                          onChange={handleChange}
                          type="text"
                          error={validationStatus.type === BankDetailFields.RE_ACCOUNT_NO ? validationStatus.msg : ""}
                          inputTextClass="line-input-box"
                          containerClass="input-container flex-fill"
               />
           </div>
            <div className="d-flex">
                <div>
                    <img className="mt-1 mr-2" src={`${imageBaseUrl}/img/icons/eGold/ifsc-icon.png`} style={{width: "16px"}}/>
                </div>
                <TextField label="IFSC Code"
                           value={bankDetails.IFSC}
                           fieldName={BankDetailFields.IFSC}
                           onChange={handleChange}
                           type="text"
                           error={validationStatus.type === BankDetailFields.IFSC ? validationStatus.msg : ""}
                           inputTextClass="line-input-box"
                           containerClass="input-container flex-fill"
                />
            </div>
            <div className={"text-danger"}>
                {ifscResponse}
            </div>
        </div>
    );
}
function renderCheckField(handleChecked, name) {
    return(
        <div className="mt-5 d-flex">
            <input type="checkbox"
                   onChange={handleChecked}
                   name="terms"
                   className="position-relative mx-1"
                   style={{top: "2px"}}
            />
            <small> I confirm that the account primary owner as per bank records is: {name}</small>
        </div>
    );

}
const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        eGoldUserDetails: state.eGold.eGoldUserDetails,
        verifySellPrice: state.eGold.verifySellPrice,
        bankDetailsValidStatus: state.eGold.bankDetailsValidStatus,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(BankDetails);
